export default [
  { value: 'galax_pay', label: 'Galax Pay' },
  { value: 'bb', label: 'Banco do Brasil' }
];
